<script>
import { Tooltip } from 'element-ui';

export default {
  extends: Tooltip,
  props: {
    openDelay: {
      type: Number,
      default: 500,
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tooltip__popper {
  border-radius: 8px;
  max-width: 300px;
}

.el-tooltip__popper.is-blue {
  background: $--color-primary-dark-3;
  color: $--color-white;

  @each $direction, $property in (top: 'top', right: 'right', bottom: 'bottom', left: 'left') {
    &[x-placement^='#{$direction}'] {
      :deep() {
        .popper__arrow {
          border-#{$property}-color: $--color-primary-dark-3;

          &::after {
            border-#{$property}-color: $--color-primary-dark-3;
          }
        }
      }
    }
  }
  :deep() {
    a {
      color: $--color-white;
    }
  }
}

.el-tooltip__popper--airy {
  font-size: rem(13px);
  line-height: rem(20px);
}
</style>
